import styles from "./index.module.scss";
import { NextPage } from "next";
import StockHolders from "@/components/stock-holders/StockHolders";
import { Stock } from "@/models/stock";
import Head from "next/head";
import { buildStockOgImage } from "@/lib/stock-og";
import { useSetAtom } from "jotai";
import { stockTradingItemIdState } from "@/lib/store";
import { useEffect } from "react";
import { stockPageGetServerSideProps } from "@/lib/stock-page-ssr";
import { stockDescriptions, stockTitle } from "@/lib/stock-seo";
import { stockCanonicalUrl } from "@/lib/stock-url";

const StockHoldersPage: NextPage<{ stock: Stock }> = ({ stock }) => {
    const setStockTradingItemId = useSetAtom(stockTradingItemIdState);

    useEffect(() => {
        stock ? setStockTradingItemId(stock.tradingitem_id) : setStockTradingItemId(null);
    }, [stock]);
    return (
        <>
            {stock &&
                (() => {
                    const { ogImageUrl, cardTitle } = buildStockOgImage(stock, "Holders");
                    return (
                        <Head>
                            <title>{stockTitle(stock, "holders")}</title>
                            <link rel="canonical" href={stockCanonicalUrl(stock, "holders")} />
                            <meta name="keywords" content={`${stock.name}, ${stock.exchangesymbol}:${stock.ticker}, Holders, Institutions, Institutional Owners`} />
                            <meta name="description" content={stockDescriptions.holders(stock)} />
                            <meta name="twitter:card" content="summary_large_image" />
                            <meta name="twitter:title" content={stockTitle(stock, "holders")} />
                            <meta name="twitter:description" content={stockDescriptions.holders(stock)} />
                            <meta name="twitter:url" content={stockCanonicalUrl(stock, "holders")} />
                            <meta name="twitter:image" content={ogImageUrl} />
                            <meta name="twitter:image:alt" content={cardTitle} />
                            <meta property="og:title" content={stockTitle(stock, "holders")} />
                            <meta property="og:description" content={stockDescriptions.holders(stock)} />
                            <meta property="og:url" content={stockCanonicalUrl(stock, "holders")} />
                            <meta property="og:image" content={ogImageUrl} key="og:image" />
                            <meta property="og:image:width" content="1200" />
                            <meta property="og:image:height" content="630" />
                            <meta property="og:image:alt" content={cardTitle} />
                        </Head>
                    );
                })()}
            <div className={styles.StockHoldersPage}>{stock ? <StockHolders stock={stock} /> : <h1>Stock not found.</h1>}</div>
        </>
    );
};

export const getServerSideProps = stockPageGetServerSideProps({ tab: "holders", allowedTypes: [1] });

export default StockHoldersPage;
